<mat-expansion-panel [expanded]="isExpanded" (click)="(toggleExpansion)">
  <mat-expansion-panel-header>
    <mat-panel-title> Filters </mat-panel-title>
  </mat-expansion-panel-header>

  <form [formGroup]="form">
    <div class="form-row mb-4">
      <div
        class="col-md-6 col-lg-6 col-xl-6 col-sm-12"
        *ngIf="isVisible('dateFrom')"
      >
        <label class="form-label">From date</label>
        <input
          type="text"
          formControlName="dateFrom"
          class="form-control"
          placeholder="Start typing here"
        />
      </div>
      <div
        class="col-md-6 col-lg-6 col-xl-6 col-sm-12"
        *ngIf="isVisible('dateFrom')"
      >
        <label class="form-label">To date</label>
        <input
          type="text"
          formControlName="dateTo"
          class="form-control"
          placeholder="Start typing here"
        />
      </div>

      <div
        class="col-md-6 col-lg-6 col-xl-6 col-sm-12"
        *ngIf="isVisible('institution')"
      >
        <label class="form-label">Hospital</label>
        <select
          class="form-control"
          formControlName="institution"
          (ngModelChange)="onInstitutionChanged()"
        >
          <option [ngValue]="null">Select hospital</option>
          <option
            [ngValue]="institution"
            *ngFor="let institution of institutions"
          >
            {{ institution.name }}
          </option>
        </select>
      </div>

      <div
        class="col-md-6 col-lg-6 col-xl-6 col-sm-12"
        *ngIf="isVisible('isSuccess')"
      >
        <label class="form-label">Success</label>
        <select class="form-control" formControlName="isSuccess">
          <option [ngValue]="null">Select</option>
          <option [ngValue]="key" *ngFor="let key of isSuccessOptions">
            {{ key }}
          </option>
        </select>
      </div>

      <div
        class="col-md-6 col-lg-6 col-xl-6 col-sm-12"
        *ngIf="isVisible('movementType')"
      >
        <label class="form-label">Movement Type</label>
        <select class="form-control" formControlName="movementType">
          <option [ngValue]="null">Select</option>
          <option [ngValue]="key" *ngFor="let key of movementTypeOptions">
            {{ key }}
          </option>
        </select>
      </div>

      <div
        class="col-md-6 col-lg-6 col-xl-6 col-sm-12"
        *ngIf="isVisible('location')"
      >
        <label class="form-label">Location</label>
        <select class="form-control" formControlName="location">
          <option [ngValue]="null">Select location</option>
          <option [ngValue]="location" *ngFor="let location of locations">
            {{ location.name }}
          </option>
        </select>
      </div>

      <div
        class="col-md-6 col-lg-6 col-xl-6 col-sm-12"
        *ngIf="isVisible('stockLocation')"
      >
        <label class="form-label">Stock Location</label>
        <select class="form-control" formControlName="stockLocation">
          <option [ngValue]="null">Select stock location</option>
          <option
            [ngValue]="stockLocation"
            *ngFor="let stockLocation of stockLocations"
          >
            {{ stockLocation.name }}
          </option>
        </select>
      </div>

      <div
        class="col-md-6 col-lg-6 col-xl-6 col-sm-12"
        *ngIf="isVisible('fromLocation')"
      >
        <label class="form-label">From Location</label>
        <select class="form-control" formControlName="fromLocation">
          <option [ngValue]="null">Select from location</option>
          <option [ngValue]="stockLocation" *ngFor="let stockLocation of stockLocations">
            {{ stockLocation.name }}
          </option>
        </select>
      </div>

      <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12" *ngIf="isVisible('toLocation')">
        <label class="form-label">To Location</label>
        <select class="form-control" formControlName="toLocation">
          <option [ngValue]="null">Select to location</option>
          <option [ngValue]="stockLocation" *ngFor="let stockLocation of stockLocations">
            {{ stockLocation.name }}
          </option>
        </select>
      </div>

      <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12" *ngIf="isVisible('patientNumber')">
        <label class="form-label">Patient Number</label>
        <input type="text" formControlName="patientNumber" class="form-control" placeholder="Start typing here" />
      </div>

      <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12" *ngIf="isVisible('caseNumber')">
        <label class="form-label">Case Number</label>
        <input type="text" formControlName="caseNumber" class="form-control" placeholder="Start typing here" />
      </div>
      <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12" *ngIf="isVisible('userName')">
        <label class="form-label">User Name</label>
        <input type="text" formControlName="userName" class="form-control" placeholder="Start typing here" />
      </div>
      <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12 slider-container" *ngIf="isVisible('timeFrom')">
        <label class="form-label">Time From</label>
        <div class="slider-label-container">
          <mat-slider min="0" max="24" step="1" #ngSlider><input matSliderThumb [value]="timeFrom" (change)="updateTimeFromValue({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})" #ngSliderThumb="matSliderThumb" (input)="updateTimeFromSliderValue({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})" /></mat-slider>
          <span><b>{{ timeFrom }}:00</b></span>
        </div>
      </div>
      <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12 slider-container" *ngIf="isVisible('timeTo')">
        <label class="form-label">Time To</label>
        <div class="slider-label-container">
          <mat-slider min="0" max="24" step="1" #ngSlider><input matSliderThumb [value]="timeTo" (change)="updateTimeToValue({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})" #ngSliderThumb="matSliderThumb" (input)="updateTimeToSliderValue({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})" /></mat-slider>
          <span><b>{{ timeTo }}:00</b></span>
        </div>
      </div>
      <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12" *ngIf="isVisible('trainingType')">
        <label class="form-label">Training Types</label>
        <select class="form-control" formControlName="trainingType">
          <option [ngValue]="null">Select type</option>
          <option [ngValue]="trainingType" *ngFor="let trainingType of trainingTypes">
            {{ trainingType }}
          </option>
        </select>
      </div>
      <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12" *ngIf="isVisible('trainingStatus')">
        <label class="form-label">Status</label>
        <select class="form-control" formControlName="trainingStatus">
          <option [ngValue]="null">Select status</option>
          <option [ngValue]="trainingStatus" *ngFor="let trainingStatus of trainingStatuses">
            {{ trainingStatus.name }}
          </option>
        </select>
      </div>
      <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12" *ngIf="isVisible('packName')">
        <label class="form-label">Pack Name</label>
        <input type="text" formControlName="packName" class="form-control" placeholder="Start typing here" />
      </div>
      <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12" *ngIf="isVisible('barcode')">
        <label class="form-label">Barcode</label>
        <input type="text" formControlName="barcode" class="form-control" placeholder="Start typing here" />
      </div>
      <div
        class="col-md-6 col-lg-6 col-xl-6 col-sm-12"
        *ngIf="isVisible('isManagedBySourceOfRecords')"
      >
        <label class="form-label">Managed By Source Of Records</label>
        <select class="form-control" formControlName="isManagedBySourceOfRecords">
          <option [ngValue]="null">Select</option>
          <option [ngValue]="key" *ngFor="let key of isManagedBySourceOfRecordsOptions">
            {{ key }}
          </option>
        </select>
      </div>
      <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12" *ngIf="isVisible('piNumber')">
        <label class="form-label">PI Number</label>
        <input type="text" formControlName="piNumber" class="form-control" placeholder="Start typing here" />
      </div>
      <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12" *ngIf="isVisible('piReference')">
        <label class="form-label">PI Reference</label>
        <input type="text" formControlName="piReference" class="form-control" placeholder="Start typing here" />
      </div>
    </div>

    <div class="row justify-content-between">
      <button (click)="filter()" class="btn btn-primary btn-block col-sm-5 col-md-4 col-lg-3 col-xl-3">
        {{ filterButtonText }}
      </button>
      <button (click)="export()" *ngIf="showExport"
        class="btn btn-primary btn-block col-sm-5 col-md-4 col-lg-3 col-xl-3">
        {{ exportButtonText }}
      </button>
      <button (click)="export2()" *ngIf="showExport2"
        class="btn btn-primary btn-block col-sm-5 col-md-4 col-lg-3 col-xl-3">
        {{ export2ButtonText }}
      </button>
    </div>
  </form>
</mat-expansion-panel>